module.exports = __webpack_public_path__ + "static/Shemaroo-af723f8f48743c43658bb47312e26988.png";